import { createElementVNode as _createElementVNode, unref as _unref, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@public/img/landing-hero.png'
import _imports_1 from '@public/img/landing-hero-globe.webp'


const _hoisted_1 = { class: "page landing-page" }
const _hoisted_2 = { class: "hero-container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "win-container"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "pl-xxl-3 pr-xxl-3" }
const _hoisted_8 = ["href"]

import { computed, watch, ref } from 'vue';
    import { useI18next } from '@composables/i18next';
    import { useBasePage } from '@composables/page';
    import { useStore } from 'vuex';


    // Setup
    
export default {
  __name: 'LandingPage',
  setup(__props) {

    useBasePage('landing', ['has-background-warm-neutral']);
    const store = useStore();
    const { t, vT } = useI18next('landing');
    const locale = ref(store.state.app.locale);


    // Computed
    const ctaHref = computed(() =>
        t(`cta.${phase.value}.href`) || store.state.app.sbuxAuthorizeURL);

    const phase = computed(() =>
        (['expired', 'launched', 'pre-launch', 'survey'].includes(store.state.app.phase) ?
            store.state.app.phase : 'launched'));

    const shouldShowSections = computed(() => ['pre-launch', 'launched'].includes(phase.value));


    // Methods
    function getSectionImageSource (section) {
        return require(`../../img/landing-section-${section}.webp`);
    }


    // Watch
    watch(shouldShowSections, (value) => {
        if (value) {
            document.body.classList.add('footer-background-sugarwinkle');
        }
        else {
            document.body.classList.remove('footer-background-sugarwinkle');
        }
    }, { immediate: true });

return (_ctx, _cache) => {
  const _directive_track = _resolveDirective("track")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "landing-header" }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "hero-image",
        alt: "Starbucks gifts image"
      }),
      _createElementVNode("img", {
        src: _imports_1,
        class: "hero-image-globe",
        alt: "Starbucks gifts globe image"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("h2", null, null, 512), [
        [_unref(vT), `headline.${phase.value}`]
      ]),
      _withDirectives(_createElementVNode("p", null, null, 512), [
        [_unref(vT), `body.${phase.value}`]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("a", {
        href: ctaHref.value,
        class: "button large color-4"
      }, [
        _withDirectives(_createElementVNode("span", null, null, 512), [
          [_unref(vT), `cta.${phase.value}.text`]
        ])
      ], 8, _hoisted_3)), [
        [_directive_track, ['Click', { category: 'Landing', label: 'Sign in', value: _unref(store).state.profile.id }]]
      ])
    ]),
    (shouldShowSections.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locale.value.includes('CA') ? 3 : 4, (section) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `section-${section}`,
              class: "section-container"
            }, [
              _createElementVNode("img", {
                src: getSectionImageSource(section),
                alt: "",
                "aria-hidden": ""
              }, null, 8, _hoisted_5),
              _withDirectives(_createElementVNode("h3", _hoisted_6, null, 512), [
                [_unref(vT), `sections.${section}.headline`]
              ]),
              _withDirectives(_createElementVNode("p", _hoisted_7, null, 512), [
                [_unref(vT), `sections.${section}.body`]
              ])
            ]))
          }), 128)),
          _createElementVNode("a", {
            href: ctaHref.value,
            class: "button large color-4"
          }, [
            _withDirectives(_createElementVNode("span", null, null, 512), [
              [_unref(vT), `cta.${phase.value}.text`]
            ])
          ], 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}